var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilmSlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.6038 11.5237L8.6301 8.07373L4.8976 9.05873C4.77316 9.09042 4.65625 9.14651 4.55365 9.22373C4.45105 9.30096 4.36481 9.39779 4.29992 9.50861C4.23504 9.61942 4.1928 9.74202 4.17567 9.86928C4.15853 9.99655 4.16684 10.1259 4.2001 10.25L5.2201 14L14.6038 11.5237Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5517 8.11636L22.038 9.04395L17.2939 6.30507L24.0665 4.51844L24.069 4.51776C24.1929 4.48437 24.3251 4.50122 24.4367 4.56464C24.5478 4.62779 24.6296 4.73204 24.6646 4.85491L25.5517 8.11636Z",
    fill: "#343330",
    stroke: "#B8772A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 14H27.1665V25C27.1665 25.2652 27.0611 25.5196 26.8736 25.7071C26.6861 25.8946 26.4317 26 26.1665 26H6.1665C5.90129 26 5.64693 25.8946 5.4594 25.7071C5.27186 25.5196 5.1665 25.2652 5.1665 25V14Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2201 14L26.1663 8.47122L25.1463 4.72122C25.076 4.47089 24.9097 4.25842 24.6836 4.12994C24.4576 4.00146 24.1899 3.96733 23.9388 4.03497L4.8976 9.05872C4.77316 9.09041 4.65625 9.1465 4.55365 9.22372C4.45105 9.30095 4.36481 9.39778 4.29992 9.50859C4.23504 9.61941 4.1928 9.74201 4.17567 9.86927C4.15853 9.99654 4.16684 10.1259 4.2001 10.25L5.2201 14Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63037 8.07373L14.6041 11.5237",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9927 6.13135L21.9664 9.5801",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmSlate);
export default __webpack_public_path__ + "static/media/FilmSlate.bcc83fb6cf8700f22497a2868a06b040.svg";
export { ForwardRef as ReactComponent };